import { fromByteArray } from 'base64-js';
import { TextEncoderLite } from 'text-encoder-lite';
export class PublicAPIKeyAuthenticator {
    public_api_key;
    constructor(public_api_key) {
        this.public_api_key = public_api_key;
    }
    post_headers() {
        return {
            'X-ZONT-Public-API-Key': this.public_api_key,
        };
    }
    get_args() {
        return {
            _public_api_key: this.public_api_key,
        };
    }
    corsCredentials() {
        return 'same-origin';
    }
}
export class PasswordAuthenticator {
    username;
    password;
    static utf8Encoder = new TextEncoderLite();
    constructor(username, password) {
        this.username = username;
        this.password = password;
    }
    post_headers() {
        const raw = `${this.username}:${this.password}`;
        return {
            Authorization: 'Basic ' + fromByteArray(PasswordAuthenticator.utf8Encoder.encode(raw)),
        };
    }
    get_args() {
        return {};
    }
    corsCredentials() {
        return 'same-origin';
    }
}
